export default {
    name: 'AppButton',
    props: {
        label: String
    }
}